export default __webpack_public_path__ + "static/media/single-left-blue.e679ad9b.svg";